import { EducationRoute } from '@/modules/education/v1/api/EducationRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { PackResponse } from '@/modules/education/v1/api/v1/packs/Dto/PackResponse'

export const OFFLINE_PACK = 'c0ffee00-0000-4000-8000-000000000001'
export const OFFLINE_QUESTION = 'c0ffee00-0000-4000-8000-000000000011'
export const OFFLINE_NODE = 'c0ffee00-0000-4000-8000-000000000101'

/** GET /api/education/v1/pack: текущая пачка или новая, с отметками отвеченных вопросов */
export class GetPackRoute extends EducationRoute<null, PackResponse> {
  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/education/v1/pack'
  }

  offline(): Promise<ApiResponse<PackResponse>> {
    const now = Date.now()
    return Promise.resolve(new ApiResponse({
      success: true,
      data: new PackResponse({
        pack: { uuid: OFFLINE_PACK, createdAt: new Date(now).toISOString(), expiresAt: new Date(now + 1800 * 1000).toISOString(), period: 1800, size: 15 },
        questions: [{ uuid: OFFLINE_QUESTION, node: OFFLINE_NODE, weight: 3, key: '', data: '', answered: null }],
      }),
    }))
  }
}
